module.exports = __webpack_public_path__ + "img/18.05a6becd.webp";